import CustomTableRow from './CustomTableRow';

export default CustomTableRow;
